import { Injectable } from '@angular/core';
import { VaultApiService } from '@services/api/vault-api.service';
import { Observable } from 'rxjs';
import {
  RiskCommittee,
  RiskCommitteeKpi,
  CommitteeStatus,
} from '@interfaces/control/monitoring/responses/risk-committee.response';
import { CreateRiskCommitteeRequest } from '@interfaces/control/monitoring/requests/create-risk-committee.request';
import { VoteRiskCommitteeRequest } from '@interfaces/control/monitoring/requests/vote-risk-committee.request';

@Injectable({ providedIn: 'root' })
export class CommitteeHttpService {
  private readonly base = 'risk-committee';

  constructor(private readonly apiService: VaultApiService) {}

  getAll(status?: CommitteeStatus, companyId?: string): Observable<RiskCommittee[] | null> {
    const params: Record<string, string> = {};
    if (status) params['status'] = status;
    if (companyId) params['companyId'] = companyId;
    return this.apiService.get<RiskCommittee[]>(this.base, {}, params);
  }

  getById(id: string): Observable<RiskCommittee | null> {
    return this.apiService.get<RiskCommittee>(`${this.base}/${id}`);
  }

  getKpi(): Observable<RiskCommitteeKpi | null> {
    return this.apiService.get<RiskCommitteeKpi>(`${this.base}/kpi`);
  }

  create(data: CreateRiskCommitteeRequest): Observable<RiskCommittee | null> {
    return this.apiService.post<RiskCommittee>(this.base, data);
  }

  vote(committeeId: string, request: VoteRiskCommitteeRequest): Observable<RiskCommittee | null> {
    return this.apiService.post<RiskCommittee>(`${this.base}/${committeeId}/vote`, request);
  }

  uploadAttachments(committeeId: string, files: File[]): Observable<RiskCommittee | null> {
    return this.apiService.post<RiskCommittee>(
      `${this.base}/${committeeId}/attachments`,
      { files },
      true
    );
  }

  delete(id: string): Observable<void | null> {
    return this.apiService.delete<void>(`${this.base}/${id}`);
  }
}
